import styled from '@emotion/styled';

const StyledVideoDate = styled.span`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.24px;
`;

interface Props {
    formattedDate: string;
}

export const VideoDate = ({ formattedDate }: Props) => {
    return <StyledVideoDate>{formattedDate}</StyledVideoDate>;
};
